import { Pipe, PipeTransform } from "@angular/core";
import { MbtiLeftType, MbtiRightType } from "../interfaces/mbti";

@Pipe({
    name: 'surveyColor'
})
export class SurveyColorPipe implements PipeTransform {

    transform(factor: MbtiRightType | MbtiLeftType | undefined, style: 'color' | 'background-color' = 'background-color', type: 'badge' | 'background' = 'background'): string {
        if (factor) {
            return `${style}: ${this.colorCode(factor, type)};`;
        }
        return '';
    }

    colorCode(factor: MbtiRightType | MbtiLeftType, type: 'badge' | 'background'): string {
        switch (type) {
            case 'badge':
                return this.surveyBadgeCode(factor);
            case 'background':
                return this.surveyBackgroundCode(factor);
        }
    }
    surveyBadgeCode(factor: MbtiRightType | MbtiLeftType): string {
        switch (factor) {
            case 'I':
                return 'var(--teal-40)';
            case 'F':
                return 'var(--teal-40)';
            case 'N':
                return 'var(--purple-30)';
            case 'T':
                return 'var(--purple-30)';
            case 'J':
                return 'var(--indigo-30)';
            case 'S':
                return 'var(--indigo-30)';
            case 'E':
                return 'var(--orange-30)';
            case 'P':
                return 'var(--orange-30)';
        }
    }

    surveyBackgroundCode(factor: MbtiRightType | MbtiLeftType): string {
        switch (factor) {
            case 'I':
                return 'var(--teal-10)';
            case 'F':
                return 'var(--teal-10)';
            case 'N':
                return 'var(--purple-08)';
            case 'T':
                return 'var(--purple-08)';
            case 'J':
                return 'var(--indigo-10)';
            case 'S':
                return 'var(--indigo-10)';
            case 'E':
                return 'var(--orange-08)';
            case 'P':
                return 'var(--orange-08)';
        }
    }
}
